<template>
    <div class="class-charts" style="margin: 18px 60px 0 60px">
        <div class="canvas-box" ref="myTotalTable" style="width: 674px;height: 256px;"></div>
    </div>
</template>
<script>

export default {
    props: ["model","xAxisData","barData","lineData","name"],
    data() {
        return {
            avg: [],
            max: [],
            min: [],
            score: [],
            placeholder: [],

        };
    },
    mounted() {
        this.renderMap();
    },
    watch: {
        barData(val) {
            if (val) {
                this.renderMap();
            }
        },
    },
    methods: {
        renderMap() {
            let myTotalTable = (window.cc = this.$echarts.init(
                this.$refs["myTotalTable"]
            ));
            let option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#283b56'
                        }
                    }
                },
                grid: {
                    top: '15px',
                    bottom: '70px',   //生成的图片和底部的间距
                    right: '120px',
                },
                legend: {
                    orient: 'vertical',//可设定图例水平（horizontal）排列还是竖直排列
                    x:'right',      //可设定图例在左、右、居中
                    bottom:'20%',    
                    align: 'left',
                },
                dataZoom: {
                    show: false,
                    start: 0,
                    end: 100
                },
                xAxis: [
                    {
                        type: 'category',
                        boundaryGap: true,
                        axisLabel: {
                            formatter:function(val){
                                return val.split("").join("\n");
                            },
                            color: '#000'
                        },
                        data: this.xAxisData,

                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        scale: true,
                        max: 100,
                        min: 50,
                        axisLabel: {
                            color: '#000'
                        },
                        boundaryGap: [0.2, 0.2]
                    }
                ],
                series: [
                    {
                        name:  this.name,
                        type: 'bar',
                        data: this.barData
                    },
                    {
                        name: '平均分',
                        type: 'line',
                        data: this.lineData,
                        itemStyle: {
                            color: '#f7f324'
                        },
                    }
                ]
            }
            myTotalTable.setOption(option);
        },
    },
};
</script>
<style lang="scss" scoped>
.class-charts {
    display: inline-block;

    .canvas-box {
        // margin: 10px auto 10px;
        // width: 415px;
        // height: 200px;
        margin: 0px 0px;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/CNBMTalent/pages/barlineCharts.vue